module.exports = __webpack_public_path__ + "static/media/E2C.708c1520.JPG";